import React, { useContext, useEffect, useState } from 'react';
import FAQAccordion from './FAQAccordion';
import { FAQItem } from 'models';
import { getFAQsForTags } from 'lib/graphql';
import LoadingPanel from 'components/Progress/LoadingPanel';
import { uiContext } from 'contexts/UIContext';

interface FAQProps {
  title?: string;
  handle: string;
}

const FAQ: React.FC<FAQProps> = (props: any) => {
  const { title = "FAQ's", handle } = props;
  const { debugMode } = useContext(uiContext);
  const [FAQItems, setFAQItems] = useState<FAQItem[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const loadFAQs = async () => {
      const FAQTags = handle.split(',').map((tag: string) => tag.trim());
      const FAQs = await getFAQsForTags(FAQTags);
      setFAQItems(FAQs);
      setLoading(false);
    };
    loadFAQs();
  }, [handle]);
  if (loading && !FAQItems.length) return <LoadingPanel />;
  if (!FAQItems.length && debugMode) return <div>DEBUG MODE: No FAQ Items for: {handle}</div>;
  if (!FAQItems.length) return null;
  return <FAQAccordion title={title} items={FAQItems} />;
};

export default FAQ;
